import { Box, Button, HStack, Text, useColorModeValue } from '@chakra-ui/react';

import Card from 'components/card/Card';

interface FloatingSaveBarProps {
  onSave: () => void;
  isSaving: boolean;
}

const FloatingSaveBar = ({ onSave, isSaving }: FloatingSaveBarProps) => {
  const bgColor = useColorModeValue('white', 'gray.800');

  return (
    <Box position="fixed" bottom="20px" right="20px" zIndex={1000} maxW="500px">
      <Card bg={bgColor} p={4} shadow="lg" borderWidth="1px">
        <HStack spacing={6}>
          <Text>You have unsaved changes</Text>
          <Button
            onClick={onSave}
            isLoading={isSaving}
            loadingText="Saving..."
            colorScheme="yellow"
            variant="solid"
          >
            Save Changes
          </Button>
        </HStack>
      </Card>
    </Box>
  );
};

export default FloatingSaveBar;
